import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["preview", "imageBox"]

  connect() {
    this.sortable = Sortable.create(this.previewTarget, {
      animation: 150,
      onEnd: this.reorder.bind(this)
    })
  }

  reorder() {
    // ドラッグ終了時に hidden field の順序を preview の並びに合わせて更新
    this.imageBoxTargets.forEach((box, index) => {
      const input = box.querySelector('input[type="hidden"]')
      if (input) {
        input.dataset.position = index
      }
    })
  }
}